import { useNavigate } from "react-router-dom"

import Style from "./style"

import MainHeader from "widget/MainHeader"
import Pagenation from "widget/Pagenation"

import useGetYoutubeList from "entity/youtube/useGetYoutubeList"
import useDeleteYoutube from "entity/youtube/useDeleteYoutube"

import TStyle from "shared/style/tableStyle"
import DefaultButton from "shared/ui/DefaultButton"
import timestampCalculator from "shared/lib/timestampCalculator"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"

const YoutubeList = () => {
    const navigate = useNavigate()

    const [youtubeList] = useGetYoutubeList()
    const [deleteYoutube] = useDeleteYoutube()

    const [, setConfirm] = useConfirmModalAtom()

    const btnList = [
        {
            "label": "생성",
            "clickEvent": () => navigate("/youtube/create"),
            "deactive": false
        }
    ]
    const sizeList = ["short", "longlong", "longlonglong", "expand", "long", "medium"]
    const tableHeadList = ["IDX", "썸네일", "제목", "연결 링크", "생성 날짜", ""]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList}>유튜브 영상 목록</MainHeader>

            <TStyle.TableDiv>
                <TStyle.TableRow $title>
                    {tableHeadList.map((elem, index) =>
                        <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                    )}
                </TStyle.TableRow>
                {youtubeList?.data?.youtube_list?.map((elem, index) =>
                    <TStyle.TableRow $odd={index % 2 === 1} $exapnd>
                        <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                        <TStyle.Data $size={sizeList[1]}>
                            <Style.PreviewImg src={elem?.img} />
                        </TStyle.Data>
                        <TStyle.Data $size={sizeList[2]}>{elem?.title}</TStyle.Data>
                        <TStyle.Data $size={sizeList[3]}>{elem?.url}</TStyle.Data>
                        <TStyle.Data $size={sizeList[4]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                        <TStyle.Data $size={sizeList[5]}>
                            <DefaultButton small fitWidth clickEvent={() => navigate(`/youtube/${elem?.idx}/edit`)}>수정</DefaultButton>
                            <DefaultButton small fitWidth clickEvent={() => setConfirm("정말 삭제하시겠습니까?", () => () => deleteYoutube(elem?.idx))}>삭제</DefaultButton>
                        </TStyle.Data>
                    </TStyle.TableRow>
                )}
            </TStyle.TableDiv>

            <Pagenation maxPage={youtubeList?.data?.max_page} />
        </Style.Wrapper>
    )
}

export default YoutubeList